import { IconName } from "@blueprintjs/core"
import { SCIENT_COLORS } from "../../../../styled/scientColors"
import { WaveStatus } from "../Trading/types/common"

export const waveStatusColor = (status: WaveStatus | undefined): string => {
  switch (status) {
    case WaveStatus.CREATED:
      return SCIENT_COLORS.blue4
    case WaveStatus.RECEIVED:
      return SCIENT_COLORS.orange3
    case WaveStatus.PASSED:
      return SCIENT_COLORS.forest2
    case WaveStatus.SENT:
      return SCIENT_COLORS.blue4
    case WaveStatus.NOT_PASSED:
      return SCIENT_COLORS.red3
    case WaveStatus.PARTIALLY_PASSED:
      return SCIENT_COLORS.orange3
    case WaveStatus.CSV_UPLOAD_ERROR:
      return SCIENT_COLORS.red3
    case WaveStatus.FAILED:
      return SCIENT_COLORS.red3
    default:
      return SCIENT_COLORS.gold3
  }
}

export const getWaveStatusIcon = (status: WaveStatus | undefined): IconName => {
  switch (status) {
    case WaveStatus.CREATED:
      return "document"
    case WaveStatus.RECEIVED:
      return "inbox"
    case WaveStatus.PASSED:
      return "tick-circle"
    case WaveStatus.NOT_PASSED:
      return "cross"
    case WaveStatus.PARTIALLY_PASSED:
      return "warning-sign"
    case WaveStatus.CSV_UPLOAD_ERROR:
      return "error"
    case WaveStatus.SENT:
      return "send-to"
    case WaveStatus.FAILED:
      return "error"
    default:
      return "help"
  }
}
